/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Extendwrapupcount2Inputs */

const en_entity_extendwrapupcount2 = /** @type {(inputs: Entity_Extendwrapupcount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Wrap-Up Count`)
};

const de_entity_extendwrapupcount2 = /** @type {(inputs: Entity_Extendwrapupcount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachbearbeitungszeit Verlängerungsanzahl`)
};

/**
* | output |
* | --- |
* | "Extend Wrap-Up Count" |
*
* @param {Entity_Extendwrapupcount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_extendwrapupcount2 = /** @type {((inputs?: Entity_Extendwrapupcount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Extendwrapupcount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_extendwrapupcount2(inputs)
	return de_entity_extendwrapupcount2(inputs)
});
export { entity_extendwrapupcount2 as "entity_extendWrapupCount" }